<template>
  <v-container fill-height grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 sm12 md12 lg12 first-row>
        <ComponentGiftcardTableList/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { tablePaginationMixin } from '@/mixins/tablePaginationMixin'
import { statusColor } from '@/mixins/statusColor'
import ComponentGiftcardTableList from '@/components/giftcard/ComponentGiftcardTableList.vue'

export default {
  mixins: [tablePaginationMixin, statusColor],

  components: {
    ComponentGiftcardTableList
  },
  data () {
    return {}
  }
}
</script>
